import { render, staticRenderFns } from "./receipts.vue?vue&type=template&id=d4299788&scoped=true"
import script from "./receipts.vue?vue&type=script&lang=js"
export * from "./receipts.vue?vue&type=script&lang=js"
import style0 from "./receipts.vue?vue&type=style&index=0&id=d4299788&prod&lang=css"
import style1 from "./receipts.vue?vue&type=style&index=1&id=d4299788&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4299788",
  null
  
)

export default component.exports